<template>
  <svg
    :width="width"
    :height="height"
    version="1.1"
    id="layer"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 652 652"
    style="enable-background: new 0 0 652 652"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M231.3,307.9v8h-0.7c-3.2-5.6-9.7-9.5-19-9.5c-13.7,0-26,10.8-26,29.9c0,19.1,12.1,30,26,30
	c9,0,14.3-3.7,18.3-9.8h0.6v12.3c0,6.6-3.6,9.6-9.6,9.6h-28.6v12.5h28.3c15.7,0,24-8.8,24-23.1v-59.9H231.3z M215.5,353.5
	c-9.4,0-15.3-5.8-15.3-17.2S206,319,215.5,319c9.1,0,15.2,5.8,15.2,17.2S224.6,353.5,215.5,353.5z M136.9,366.2v-33.8
	c0-8.3,5.1-13.7,13.4-13.7c7.9,0,12.6,4.6,12.6,13.5v33.9H177V330c0-14.7-7.1-23.6-21.7-23.6c-8.9,0-15.7,4-18.8,9.5H136v-8h-13.2
	v58.3L136.9,366.2z M110.9,307.9H96.8v58.3h14.1V307.9z M72.3,326v-0.6c8.6-2.4,14.5-8.2,14.5-21.2c0-13.4-10-23.1-28.4-23.1H27v85
	h14.6v-33.8h17.7c8.3,0,12.4,4.1,12.4,12.4v21.4h14.6v-21.4C86.3,332.8,81.2,327.9,72.3,326z M57.5,319.3h-16v-25h16
	c7.9,0,14,3.3,14,12.5C71.5,316,65.4,319.3,57.5,319.3z"
    />
    <path
      class="st1"
      d="M627,276.3h-14.1v89.9H627V276.3z M577.6,306.4c-13,0-23.1,6.3-24.8,19.2h13.8c1-4.9,4.6-7.8,10.9-7.8
	c7.4,0,10.8,4.2,10.8,10.9v3h-14.2c-13.1,0-22.8,5.8-22.8,17.7c0,11.9,7.9,18.1,19.3,18.1c8.9,0,14.7-3.8,17.9-9.8h0.6v8.3h13.4
	v-36.9C602.5,315,595.2,306.4,577.6,306.4z M574.7,356.8c-5.5,0-8.9-2.7-8.9-7.1c0-5.1,3.6-7.8,10.2-7.8h12.3l0.1,0.8
	C588.4,351.6,583.3,356.8,574.7,356.8z M526.4,366.2v-30.2c0-9,5.6-14.7,14.5-14.7h5.5v-13.4h-5.7c-6.7,0-11.5,2.5-14.6,8.3h-0.5
	v-8.3h-13.2v58.3L526.4,366.2z M503.5,353.3v12.9h-9.6c-13.5,0-20.9-6.3-20.9-19.7v-27h-9.6v-11.6h9.6v-15.5h14.1v15.5h16.4v11.6
	h-16.4v25.4c0,5.3,3.2,8.5,8.5,8.5H503.5z M417.2,366.2v-33.8c0-8.3,5.1-13.7,13.4-13.7c7.9,0,12.6,4.6,12.6,13.5v33.9h14.1V330
	c0-14.7-7.1-23.6-21.7-23.6c-8.9,0-15.7,4-18.7,9.5h-0.5v-8h-13.2v58.3L417.2,366.2z M365.5,356.1c-8.9,0-14.8-6-15.1-15.3h43.1
	l-0.1-4.6c0-19.5-12.6-29.8-28.1-29.8c-16.7,0-28.8,11.9-28.8,30.6c0,18.7,11.3,30.6,28.8,30.6c14.7,0,24.3-7.8,27.1-19.2h-13.7
	C377.3,352.9,373.6,356.1,365.5,356.1z M365.4,318.1c9.2,0,14.7,5.2,15.1,12.5h-30.1C351.7,323.2,356.2,318.1,365.4,318.1z
	 M294.4,367.7c21,0,32.9-11.7,35.7-29h-14.3c-2.1,7.9-7.9,15.2-21.4,15.2c-14,0-25.1-9.5-25.1-30.4c0-20.8,11.2-30.3,25.1-30.3
	c14,0,19.6,7.3,21.4,15.1h14.3c-2.3-17.3-14-28.6-35.7-28.6c-23.3,0-40.2,16.3-40.2,44C254.2,351.6,271.1,367.8,294.4,367.7
	L294.4,367.7z M103.9,298.5c1.9,0,3.7-0.5,5.2-1.6c1.5-1,2.7-2.5,3.5-4.2c0.7-1.7,0.9-3.6,0.5-5.4c-0.4-1.8-1.3-3.5-2.6-4.8
	c-1.3-1.3-3-2.2-4.8-2.6c-1.8-0.4-3.7-0.2-5.4,0.5s-3.2,1.9-4.2,3.5c-1,1.5-1.6,3.4-1.6,5.2c0,1.9,0.5,3.7,1.6,5.2
	c1,1.5,2.5,2.7,4.2,3.4C101.4,298.3,102.7,298.5,103.9,298.5z M93.1,263.2c-3.4,1.4-6.5,3.5-9.1,6.1l6.6,6.6
	c1.7-1.7,3.8-3.1,6.1-4.1c2.3-0.9,4.7-1.4,7.2-1.4c2.5,0,4.9,0.5,7.2,1.4c2.3,0.9,4.3,2.3,6.1,4l6.6-6.6c-3.9-3.9-8.9-6.6-14.4-7.7
	C103.9,260.6,98.3,261.1,93.1,263.2z"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RingCentralLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>